import { render, staticRenderFns } from "./Congress.vue?vue&type=template&id=733e8229"
import script from "./Congress.vue?vue&type=script&lang=js"
export * from "./Congress.vue?vue&type=script&lang=js"
import style0 from "./Congress.vue?vue&type=style&index=0&id=733e8229&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports